module.exports = __webpack_public_path__ + "static/media/audience-restriction.37a50837.svg";